import { useQuery } from '@tanstack/react-query';
import apiClient from './apiClient';

export const operationalDestinationKeys = {
  all: ['operationalDestinations'],
  lists: () => [...operationalDestinationKeys.all, 'list'],
};

/** Destinos de uso interno habilitados para pedidos de materiales. */
export const useOperationalDestinations = () =>
  useQuery({
    queryKey: operationalDestinationKeys.lists(),
    queryFn: async () => (await apiClient.get('operational_destinations')).data,
    staleTime: 5 * 60 * 1000,
  });
